import { render, staticRenderFns } from "./DiscountsList.vue?vue&type=template&id=03c03128&scoped=true&"
import script from "./DiscountsList.vue?vue&type=script&lang=js&"
export * from "./DiscountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c03128",
  null
  
)

export default component.exports